import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { OBJLoader } from "three/addons/loaders/OBJLoader.js";
import { STLLoader } from "three/addons/loaders/STLLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";

import * as THREE from "three";
import { useThree, useFrame } from "@react-three/fiber";
import {
  InjectDrawCutsAndButtonsData,
  SetElasticsGLBData,
  SetGroup as SetElasticsGroup,
  StartExecution,
  PrepareCutsAndButtonsData,
  elasticsFormatedData,
} from "./Elastics";
import {
  computeBoundsTree,
  disposeBoundsTree,
  acceleratedRaycast,
  MeshBVH,
} from "three-mesh-bvh";
import { placeIPRBetweenTeeth, updateIPRBetweenTeeth } from "@/helpers/ipr";
import { GUI } from "dat.gui";
import { getParams } from "@/helpers/getParams";
import { useGlobalStore } from "../../store";
import {
  PrepareTeethMovementPath,
  areColliding,
  calculateTeethPositions,
} from "./teethControls/TeethPositionHelper";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {
  addRemoveAttachment,
  onPointerMove,
  selectTooth,
  newAttachmentMaterial,
  setAttachmentArray,
  attachmentArray1,
} from "./teethControls/addRemoveAttachment";
import {
  assignPonticsMaterial,
  assignPonticsToGroup,
  ponticsData,
  ponticsTeethMaterial,
} from "./controls/Pontics";
import {
  globalBiteJump,
  isBJ,
  globalMaxStepNumber,
  myOTP,
  fillWithDefaultColor,
  teethMovementData,
  teethMovementDataPerStep,
} from "./Scene";
import { useCustomTranslation } from "@/hooks/useTranslation";
import { isComparingMode } from "./modifications/ComparePlans";
import { isAppleMobile, isIpad } from "@/helpers/detectBrowser";
import MeasurementTool from "./controls/measurementTool.ts";
export const measurementTool = new MeasurementTool();

import CustomRotationControls from "./controls/customControls";
import { TeethHeatmapGenerator } from "./HeatmapsNew";
import { OcclusalArea, OcclusalSceneController } from "@/helpers/occ";
import {
  occlusalSplitGroup,
  setMeshGroup3,
  setRootGroup,
  splitTreatmentGeneration,
  changeCameraLayers as changeCameraLayersSplit,
  rootGroup as rootGroupSplit,
} from "./Split";
import { addEventListener } from "@/helpers/clickManager";
// import { otp_cbct as otp } from "./OTPs/OTPFileJM.js/index.js";
import { TreatmentSetup } from "./TreatmentSetup.ts";
import { Jaw } from "./interfaces.ts";
import { SingletonManager } from "../../helpers/singletonInitializer.ts";
import { GLBDataV2 } from "./localTSReader.js";
import { globalData, setToggle } from "../../helpers/globData.ts";
import {
  BJStepHeatmap,
  lowerMatrix,
  lowerMatrixInversed,
  setIsBiteJumpActive,
  upperMatrix,
  upperMatrixInversed,
} from "./Bitejump.ts";
import { enableLayersOf, RB } from "./rootsAndBonesManager.js";
import { rootsValues } from "../../utils/enums.js";
import { drawSphere } from "../hierarchyHelper.js";
import { ConvexGeometry } from "three/addons/geometries/ConvexGeometry.js";
import { customTeethGizmoControls } from "./Camera.jsx";
import { iprOverlays } from "../../helpers/ipr.js";
import {
  exportToDraco,
  exportToDracoWithTransform,
} from "../../helpers/drcExporter.js";
import ApolloExporter from "../customizer/Apollo/ApolloExporter.ts";
import ETPExporter from "../customizer/Choho/ETPExporter.ts";
import { step } from "three/examples/jsm/nodes/Nodes";
import { get } from "lodash";
import { numberingFdi } from "../../helpers/teethNumbering.js";
THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;
const holderCopyRoots = [];
const holderCopyBase = [];
const gingivaCopy = [];

export const Controller = new CustomRotationControls();
/**
 * Centralized runtime registry for treatment plan elements (Steps, gums, teeth).
 *
 * Maps Three.js object `id`s to their corresponding step, gum, and tooth meshes.
 * Enables O(1) access to elements without traversing the scene graph.
 *
 * Usage:
 * - `TPLookupObject.teethById[id]` → returns the cloned tooth mesh.
 * - `TPLookupObject.stepsById[id]` → returns the step group.
 * - `TPLookupObject.gumsById[id]`  → returns the gum mesh or group.
 */
export const tpLookup = {
  stepsById: {},
  gumsById: {},
  teethById: {},
  splitStepsById: {},
  splitGumsById: {},
  splitTeethById: {},
};

let BJGroup = new THREE.Group();
let optionCounter = 0;
export let teethMeshObject = {};

let isElasticsGroupAssigned = false,
  isPonticsGroupAssigned = false;
export let FETreatmentGeneration, heatmapsGenerator;
let once = 0;
let guiCounter = 0;
let conf = { color: "#fff9f9" }; //teeth color
let conf1 = { color: "#2e2e2e" }; // specular color
let conf5 = { color: "#303030" }; // emissive gum color
let conf2 = { color: "#ff9090" }; // gum color
let conf3 = { color: "#ff93ab" }; // emissive color
let conf4 = { color: "#ffe2e6" }; // Spec gum color
const turnGUIOn = false;
let rootsAreCreated = false;
const turnCutsOn = false;
let isIPRPlaced = false;
export let isOrbitControlsAuthorized = false;

export function setIsOrbitControlsAuthorized(state) {
  isOrbitControlsAuthorized = Boolean(state);
}

export let isAdvancedHeatmaps = false;
export function setIsAdvancedHeatmaps(state) {
  isAdvancedHeatmaps = state;
}

export let heatMapManager;
export let occlusalAreaManager, occlusalSceneController;
export let splitScene, mainScene;
const occlusalMainGroup = new THREE.Group();

let oldOptions = {};
let orbitControlSwitch = true;
let attachmentsList = [];
let globalCurrentStep;
let selectedAttachment;
// let selectedAttachmentOffset;
const tempParent = new THREE.Group();
const geometry = new THREE.BufferGeometry();

const line = new THREE.Line(
  geometry,
  SingletonManager.materialManager.createMaterial("LineBasicMaterial", {
    name: "Line Material",
  }),
);
export let attachmentMaterial = SingletonManager.materialManager.createMaterial(
  "MeshPhysicalMaterial",
  {
    color: 0xef8e9a,
    roughness: 0,
    transparent: false,
    side: THREE.DoubleSide,
    name: "attachmentMaterial",
  },
);

let gumMaterial;

let meshGroup, rootGroup, heatmapsGroup;

export let reluAlignmentVector = new THREE.Vector3();

let cameraRotationListener;
export let teethMaterial,
  defaultTeethMaterial,
  occlusalTeethMaterial,
  selectedTeethMaterial,
  lockedTeethMaterial,
  boneMaterial;

export let invisibleMat = SingletonManager.materialManager.createMaterial(
  "MeshPhysicalMaterial",
  {
    transparent: true,
    opacity: 0,
    name: "invisibleMat",
  },
);
export let tpWithoutBiteJumpWithMod2 = [];
export let boundingTreeCount = 1;
let isPathReady = false;
let CBCTTeethGroup,
  CBCTTeethGroup1,
  CBCTTeethGroup3,
  gingivaGroup,
  CBCTTeethGroupMA;
let diffResult;
export function disposeObject(object) {
  object.geometry.dispose();
  object.material.dispose();
}

export function prepareConvex(object) {
  const points = [];
  const positionAttribute = object.geometry.getAttribute("position");

  if (!positionAttribute || object.userData["pontic"]) {
    return new THREE.Mesh();
  }
  for (let i = 0; i < positionAttribute.array.length; i++) {
    const vertex = new THREE.Vector3();
    vertex.fromBufferAttribute(positionAttribute, i);

    points.push(vertex);
  }

  const convexGeometry = new ConvexGeometry(points);

  let result = new THREE.Mesh(
    convexGeometry,
    new THREE.MeshBasicMaterial({
      color: 0x00ff00, // Green
      wireframe: true,
      transparent: true,
      opacity: 0.5,
    }),
  );

  // console.log(object.geometry.index.count);
  // console.log(result.geometry.attributes.position.count);

  return result;
}
export function replaceLastStepWithLastOriginalStep(groupRef, groupRef2) {
  const maxStepNumber = groupRef2.current.children.length - 1;

  const tpBiteJumpClone0 = tpWithoutBiteJumpWithMod2[0];
  const tpBiteJumpClone1 = tpWithoutBiteJumpWithMod2[1];

  tpBiteJumpClone0.parent = groupRef.current.children[maxStepNumber];
  tpBiteJumpClone0.visible = true;
  groupRef.current.children[maxStepNumber].children[0] = tpBiteJumpClone0;
  tpBiteJumpClone1.parent = groupRef.current.children[maxStepNumber];
  tpBiteJumpClone1.visible = true;
  groupRef.current.children[maxStepNumber].children[1] = tpBiteJumpClone1;
}
/**
 *
 * @param {Camera} camera
 * @param {String} listenerName
 * @param {String} listenerGroup
 * @returns {Bool}
 */
export function checkCameraListenerExistance(
  camera,
  listenerName,
  listenerGroup,
) {
  let state = false;
  for (
    let index = 0;
    index < camera._listeners[listenerGroup].length;
    index++
  ) {
    if (camera._listeners[listenerGroup][index].name == listenerName) {
      state = true;
      break;
    }
  }
  return state;
}

export function findRootParent(root, originalTeeth, scene) {
  if (!originalTeeth?.length) {
    // console.log("no parent found for tooth");
    return null;
  }
  const reluAlignmentVectorLengthSq = reluAlignmentVector.lengthSq();
  const rootJaw = parseInt(root.name.substring(1)) > 16 ? Jaw.Lower : Jaw.Upper;
  const alignmentFunction =
    rootJaw === Jaw.Upper ? getLowestVertex : getHighestVertex;
  const results = [];
  const doesDraw = false;

  for (let toothIndex = 0; toothIndex < originalTeeth.length; toothIndex++) {
    if (originalTeeth[toothIndex].userData["jaw"] !== rootJaw) {
      continue;
    }
    const doesDrawObject = false;
    const rootGlobalPos = new THREE.Vector3();
    const objectGlobalPos = new THREE.Vector3();
    root.getWorldPosition(rootGlobalPos);
    originalTeeth[toothIndex].getWorldPosition(objectGlobalPos);

    const distance = Math.abs(
      alignmentFunction(originalTeeth[toothIndex], doesDrawObject, scene)
        .add(objectGlobalPos)
        .sub(alignmentFunction(root, doesDraw, scene, true).add(rootGlobalPos))
        .lengthSq(),
    );
    // console.log(distance);

    if (distance < 7) {
      results.push({
        distance,
        tooth: originalTeeth[toothIndex],
        root,
      });
    }
  }

  if (results.length) {
    let minimumDistance = Infinity;
    let objectRef;
    for (let index = 0; index < results.length; index++) {
      const element = results[index];
      if (element.distance < minimumDistance) {
        minimumDistance = element.distance;
        objectRef = element;
      }
    }
    console.log(minimumDistance, root.name + "_" + objectRef.tooth.name);
    if (objectRef.tooth.name !== root.name) {
      console.log("Miss numbering detected");
    }
    return objectRef.tooth;
    // return originalTeeth[toothIndex];
  } else {
    console.log(root.name, "fail");

    return false;
  }
}

function getLowestVertex(object, draw, scene, red) {
  if (!object || !object.geometry || !object.geometry.attributes.position) {
    console.error("Object has no geometry.");
    return null;
  }

  let lowestVertex = new THREE.Vector3();
  let lowestY = Infinity;

  // Get vertex positions from geometry
  const position = object.geometry.attributes.position;

  const vertex = new THREE.Vector3();

  for (let i = 0; i < position.count; i++) {
    vertex.fromBufferAttribute(position, i);
    // vertex.applyMatrix4(object.matrixWorld); // Convert to world space

    if (vertex.y < lowestY) {
      lowestY = vertex.y;
      lowestVertex.copy(vertex);
    }
  }

  if (draw) {
    // console.log(object);

    // console.log(object.getWorldPosition(new THREE.Vector3()).clone());

    drawSphere(
      lowestVertex
        .clone()
        .add(object.getWorldPosition(new THREE.Vector3()).clone()),
      1,
      scene,
      red ? 0xff0000 : 0x0095dd,
    );
  }
  return lowestVertex;
}
function getHighestVertex(object, draw, scene, red) {
  if (!object || !object.geometry || !object.geometry.attributes.position) {
    console.error("Object has no geometry.");
    return null;
  }

  let highestVertex = new THREE.Vector3();
  let highestY = -Infinity;

  // Get vertex positions from geometry
  const position = object.geometry.attributes.position;

  const vertex = new THREE.Vector3();

  for (let i = 0; i < position.count; i++) {
    vertex.fromBufferAttribute(position, i);
    // vertex.applyMatrix4(object.matrixWorld); // Convert to world space

    if (vertex.y > highestY) {
      highestY = vertex.y;
      highestVertex.copy(vertex);
    }
  }
  if (draw) {
    // console.log(object.getWorldPosition(new THREE.Vector3()).clone());

    drawSphere(
      highestVertex.clone().add(object.getWorldPosition(new THREE.Vector3())),
      1,
      scene,
      red ? 0xff0000 : 0x0095dd,
    );
  }
  return highestVertex;
}

export function isVisible(object, traverses = 10) {
  let isVisibleResult = object.visible;
  let parentIndex = 1;
  let parent = object.parent;
  while (isVisibleResult && parent && parentIndex < traverses) {
    isVisibleResult = parent.visible;
    parent = parent.parent;
    parentIndex++;
  }
  return isVisibleResult;
}
let globalPerspectiveCameraRef, globalOrthographicCameraRef;
export function changeCameraLayers(layersToRender) {
  // Disable all layers first (optional, but good for clear changes)

  globalPerspectiveCameraRef.current.layers.mask = 0; // Resets all layers to disabled
  globalOrthographicCameraRef.current.layers.mask = 0; // Resets all layers to disabled

  layersToRender.forEach(layer => {
    globalPerspectiveCameraRef.current.layers.enable(layer);
    globalOrthographicCameraRef.current.layers.enable(layer);
  });
}

export function DrawContact(mesh1, mesh2, isSplit, step) {
  // const step = parseInt(mesh1.name.split("_")[1].substring(2, 5));
  const occGroupIndex = isSplit ? 1 : 0;
  let results;

  if (
    step === globalMaxStepNumber ||
    !occlusalSceneController.isOccReady(step, occGroupIndex)
  ) {
    mesh1.updateWorldMatrix(true);
    mesh2.updateWorldMatrix(true);

    results = occlusalAreaManager.createContactLines(mesh1, mesh2);
  }
  if (results) {
    occlusalSceneController.attachOcclusalToStep(results, step, occGroupIndex);
  }
  occlusalSceneController.setCurrentVisibleChild(step, occGroupIndex);
}

function Mesh({
  tploaded,
  view,
  maxStepNumber,
  GLBData: GLBData,
  perspectiveCameraRef,
  orthographicCameraRef,
  controlsRef,
  iprOverLays,
  setIprOverlays,
  numberingOverLays,
  model,
  setModel,
  isViewerControlsEnabled,
  teethTransformationData,
  ponticsData,
  setAutoSave,
  biteJumpsSteps,
}) {
  const { dentalNotation } = getParams();
  const groupRef = React.useRef(null);

  const {
    canvas,
    setRefs,
    setControls3D,
    groupRef2,
    selectedTooth,
    selectedAttachmentType,
    toggle,
    currentStep,
    logs,
    setLogs,
    setScene,
    attachmentArray,
  } = useGlobalStore(state => ({
    selectedAttachmentType: state.controls3D.selectedAttachmentType,
    selectedTooth: state.controls3D.selectedTooth,
    setRefs: state.setRefs,
    groupRef2: state.refs.groupRef2,
    canvas: state.refs.canvas,
    controlsRef: state.refs.controlsRef,
    setControls3D: state.setControls3D,
    toggle: state.toggle,
    currentStep: state.stepperControls.currentStep,
    logs: state.logs,
    setLogs: state.setLogs,
    setScene: state.setScene,
    attachmentArray: state.controls3D.attachmentArray,
    setToggle: setToggle,
  }));
  const [centerVec, setCenterVec] = useState({ x: 0, y: 0, z: 0 });

  if (!teethMaterial) {
    defaultTeethMaterial = SingletonManager.materialManager.createMaterial(
      "MeshPhysicalMaterial",
      {
        roughness: 0.4,
        reflectivity: 8,
        specularIntensity: 3,
        specularColor: 0x2e2e2e,
        emissiveIntensity: 1,

        color: conf.color,
        emissive: conf5.color,
        side: THREE.DoubleSide,
        flatShading: isAppleMobile() ? true : false,
        clearcoat: 0.8,
        // renderOrder: 10,
        name: "defaultTeethMaterial",
        vertexColors: false,
        // transparent: true,
        // opacity: 0.5,
      },
    );

    teethMaterial = SingletonManager.materialManager.cloneMaterial(
      defaultTeethMaterial,
      "teethMaterial",
    );

    boneMaterial = SingletonManager.materialManager.createMaterial(
      "MeshPhysicalMaterial",
      {
        reflectivity: -0.5,
        specularIntensity: -5,
        // specularColor: 0x2e2e2e,
        emissiveIntensity: -5,

        color: 0xfffae6,
        // emissive: conf5.color,
        side: THREE.DoubleSide,
        flatShading: isAppleMobile() ? true : false,
        // clearcoat: 0.8,
        name: "boneMaterial",
        vertexColors: false,
        transparent: true,
        opacity: 0.7,
      },
    );

    occlusalTeethMaterial = SingletonManager.materialManager.createMaterial(
      "MeshPhysicalMaterial",
      {
        roughness: 0.4,
        reflectivity: 0,
        specularIntensity: 0,
        specularColor: 0x2e2e2e,
        emissiveIntensity: 0,

        color: conf.color,
        emissive: conf5.color,
        side: THREE.DoubleSide,
        flatShading: false,
        clearcoat: 0.8,
        // renderOrder: 10,
        name: "Occlusal Teeth Material",
        vertexColors: true,
        transparent: true,
        opacity: 1,
      },
    );

    assignPonticsMaterial(
      SingletonManager.materialManager.createMaterial("MeshPhysicalMaterial", {
        roughness: 0.4,
        reflectivity: 4,
        specularIntensity: 1.5,
        specularColor: 0x2e2e2e,
        emissiveIntensity: 1,

        color: 0xbdbdbd,
        emissive: conf5.color,
        side: THREE.DoubleSide,
        flatShading: false,
        clearcoat: 0.8,
        name: "ponticsMaterial",
      }),
    );
  }
  if (!selectedTeethMaterial) {
    selectedTeethMaterial = SingletonManager.materialManager.createMaterial(
      "MeshPhysicalMaterial",
      {
        roughness: 0.4,
        reflectivity: 0,
        specularIntensity: 2,
        specularColor: "#FFFF8B",
        emissiveIntensity: 5,
        //   emissive: conf5.color,
        color: 0xc2e2ff,
        side: THREE.DoubleSide,
        flatShading: false,
        clearcoat: 0.8,
        name: "selected",
        vertexColors: false,
      },
    );
  }
  if (!lockedTeethMaterial) {
    lockedTeethMaterial = SingletonManager.materialManager.createMaterial(
      "MeshPhysicalMaterial",
      {
        roughness: 0.4,
        reflectivity: 4,
        specularIntensity: 3,
        specularColor: 0x2e2e2e,
        emissiveIntensity: 1,
        // emissive: conf5.color,
        color: "darkgray",
        side: THREE.DoubleSide,
        flatShading: false,
        clearcoat: 0.8,
        name: "locked",
      },
    );
  }
  attachmentMaterial.color.setHex(0xef8e9a);

  React.useEffect(() => {
    setRefs({
      groupRef,
    });
  }, []);

  globalPerspectiveCameraRef = perspectiveCameraRef;
  globalOrthographicCameraRef = orthographicCameraRef;

  if (!optionCounter) {
    oldOptions = toggle;
    optionCounter++;
  }

  if (groupRef.current) {
    if (!isElasticsGroupAssigned) {
      isElasticsGroupAssigned = true;
      SetElasticsGroup(groupRef, groupRef2);
      SetElasticsGLBData(GLBData);
      PrepareCutsAndButtonsData();
      InjectDrawCutsAndButtonsData();
      if (boundingTreeCount === 0 && globalData.hasElastics) {
        StartExecution();
      } else {
        console.log("this is counter ", boundingTreeCount);
      }
    }
    if (!isPonticsGroupAssigned) {
      isPonticsGroupAssigned = true;
      assignPonticsToGroup(tpLookup.teethById);
    }
  }
  if (toggle.occ) {
    ponticsTeethMaterial.side = THREE.FrontSide;
    teethMaterial.copy(occlusalTeethMaterial);
    selectedTeethMaterial.vertexColors = true;
    teethMaterial.needsUpdate = true;
    ponticsTeethMaterial.needsUpdate = true;
    selectedTeethMaterial.needsUpdate = true;
  } else {
    ponticsTeethMaterial.transparent = false;
    ponticsTeethMaterial.side = THREE.DoubleSide;
    ponticsTeethMaterial.opacity = 1;

    teethMaterial.copy(defaultTeethMaterial);
    selectedTeethMaterial.vertexColors = false;
    teethMaterial.needsUpdate = true;
    ponticsTeethMaterial.needsUpdate = true;
    selectedTeethMaterial.needsUpdate = true;
  }
  if (toggle.numbering) {
    attachmentMaterial.transparent = true;
    attachmentMaterial.opacity = 0.5;
    newAttachmentMaterial.opacity = 0.5;
    newAttachmentMaterial.needsUpdate = true;
    attachmentMaterial.side = THREE.DoubleSide;
    attachmentMaterial.needsUpdate = true;
    newAttachmentMaterial.opacity = 0.5;
    newAttachmentMaterial.transparent = true;
    newAttachmentMaterial.opacity = 0.5;
    newAttachmentMaterial.side = THREE.DoubleSide;
    newAttachmentMaterial.needsUpdate = true;
  } else {
    attachmentMaterial.transparent = false;
    attachmentMaterial.side = THREE.DoubleSide;
    attachmentMaterial.opacity = 1;
    newAttachmentMaterial.needsUpdate = true;
    attachmentMaterial.needsUpdate = true;
    newAttachmentMaterial.transparent = false;
    newAttachmentMaterial.side = THREE.DoubleSide;
    newAttachmentMaterial.opacity = 1;
    newAttachmentMaterial.needsUpdate = true;
  }

  if (toggle.attachment) {
    attachmentMaterial.visible = true;
    newAttachmentMaterial.visible = true;
  } else {
    attachmentMaterial.visible = false;
    newAttachmentMaterial.visible = false;
  }
  if (!gumMaterial) {
    gumMaterial = SingletonManager.materialManager.createMaterial(
      "MeshPhysicalMaterial",
      {
        roughness: 0.35,
        reflectivity: 0.65,
        specularIntensity: 0.35,
        specularColor: conf4.color,
        color: conf2.color,
        emissive: conf3.color,
        emissiveIntensity: 0.15,
        side: THREE.DoubleSide,
        opacity: toggle.show3DControls ? 1 : 1,
        depthWrite: toggle.show3DControls ? false : true,
        transparent: toggle.show3DControls ? true : true,
        name: "gum material",
      },
    );
  } else {
    gumMaterial.transparent = !toggle.show3DControls ? false : true;
    gumMaterial.opacity =
      toggle.show3DControls && !toggle.showContModification ? 0 : 1;
    gumMaterial.depthWrite =
      toggle.show3DControls && !toggle.showContModification ? false : true;
  }

  const centering_group = new THREE.Group();
  const scene = useThree().scene;
  const camera = useThree().camera;
  const controls = useThree().controls;
  const pointer = new THREE.Vector2();
  let raycaster = new THREE.Raycaster();
  raycaster.layers.enable(1);

  occlusalMainGroup.name = "occ_group";

  function myCallbackFunction() {
    reflectIPRVision();
  }
  if (controlsRef?.current) {
    if (
      checkCameraListenerExistance(
        controlsRef.current,
        "myCallbackFunction",
        "update",
      )
    ) {
      controlsRef.current.removeEventListener("update", cameraRotationListener);
      controlsRef.current.addEventListener("update", myCallbackFunction);
      cameraRotationListener = myCallbackFunction;
    } else {
      controlsRef.current.addEventListener("update", myCallbackFunction);
      cameraRotationListener = myCallbackFunction;
    }
  }
  useEffect(() => {
    //console.log("wat?");
    setTimeout(() => {
      myCallbackFunction();
    }, 500);
  }, [toggle.showUpper, toggle.showLower, view]);

  globalCurrentStep = currentStep;

  if (!meshGroup && GLBDataV2.isReady) {
    meshGroup = PrepareMesh(GLBData, ponticsData);
    PrepareRootGroup(RB);

    if (RB.mandible || RB.skull) {
      setRootGroup(rootGroup.clone(true));
    }

    BJGroup.visible = false;
    BJGroup.name = "BiteJumpGroup";

    thisIsTheApocalypse(GLBDataV2);
    fixSuperImpose(meshGroup);

    // loadTestDRC("TestDRC.drc", scene);
    centerGroups(FETreatmentGeneration.getCurrentStep());
    console.log("now center");

    placeIPRBetweenTeeth(meshGroup.position.z, toggle, iprOverLays);
    setMeshGroup3(meshGroup.clone(true));

    function fixSuperImpose(meshGroup) {
      const lastStep = meshGroup.children[globalData.maxStepNumber + 1];
      const superImposeMaterial = SingletonManager.materialManager.getMaterial(
        "superImposeMaterial",
      );
      for (let isLower = 0; isLower < 2; isLower++) {
        const jaw = meshGroup.children[0].children[isLower];
        for (
          let toothIndex = 0;
          toothIndex < lastStep.children[isLower].children.length;
          toothIndex++
        ) {
          const tooth = lastStep.children[isLower].children[toothIndex];
          for (let dataIndex = 0; dataIndex < 16; dataIndex++) {
            if (
              jaw.children[dataIndex].userData["number"] ===
              tooth.userData["number"]
            ) {
              tooth.geometry = jaw.children[dataIndex].geometry;
              if (jaw.children[dataIndex].children[3].children[0]) {
                tooth.children[3].attach(
                  jaw.children[dataIndex].children[3].children[0].clone(),
                );
                tooth.children[3].children[0].material = superImposeMaterial;
              }

              break;
            }
          }
        }
      }
    }

    function createSphereAt(position, radius = 0.5, color = 0xffff00) {
      const geometry = new THREE.SphereGeometry(radius, 16, 16);
      const material = new THREE.MeshBasicMaterial({ color });
      const sphere = new THREE.Mesh(geometry, material);

      sphere.position.copy(position); // Set the position
      return sphere;
    }
    // console.log(meshGroup.children.length, maxStepNumber, "there u are");

    let gum;
    const startTime1 = Date.now();

    if (isAdvancedHeatmaps) {
      const teeth = [
        ...heatmapsGroup.children[0].children[0].children,
        ...heatmapsGroup.children[0].children[1].children,
      ];
      heatmapsGenerator = new TreatmentSetup(
        teeth,
        myOTP,
        heatmapsGroup.children,
        "Heatmaps",
      );
      heatMapManager = new TeethHeatmapGenerator(heatmapsGenerator);

      FETreatmentGeneration.heatmaps = heatMapManager.getHeatmapsResult();
    } else {
      occlusalAreaManager = new OcclusalArea();
      occlusalSceneController = new OcclusalSceneController(
        [occlusalMainGroup, occlusalSplitGroup],
        globalMaxStepNumber,
      );
      // scene.updateMatrixWorld(true);
    }

    const length = heatmapsGroup.children.length;
    for (let stepIndex = 0; stepIndex < length; stepIndex++) {
      for (let isLower = 0; isLower < 2; isLower++) {
        gum = heatmapsGroup.children[stepIndex].children[isLower];

        if (!gum || !gum.geometry) {
          continue;
        }

        if (stepIndex < length - (isAdvancedHeatmaps ? 2 : 0)) {
          if (!gum.userData["boundsTree"]) {
            gum.userData["boundsTree"] = true;
            prepareBoundingTrees(gum.geometry);
          } else {
            gum.userData["boundsTree"] = true;
          }
          gum.children.forEach(tooth => {
            if (tooth.geometry.boundsTree) {
              tooth.userData["boundsTree"] = true;
            }
            if (!tooth.userData["boundsTree"]) {
              tooth.userData["boundsTree"] = true;

              prepareBoundingTrees(tooth.geometry);
            }
          });
        }

        if (!gum.userData["super"] && heatMapManager && isLower % 2 === 1) {
          heatMapManager.addTask(
            heatmapsGroup.children[stepIndex].children[0].children,
            heatmapsGroup.children[stepIndex].children[1].children,
          );

          if (isBJ && stepIndex === length - 2) {
            heatmapsGroup.children[stepIndex].children[0].applyMatrix4(
              upperMatrix,
            );
            heatmapsGroup.children[stepIndex].children[1].applyMatrix4(
              lowerMatrix,
            );

            heatMapManager.addTask(
              heatmapsGroup.children[stepIndex].children[0].children,
              heatmapsGroup.children[stepIndex].children[1].children,
              true,
            );
          }
        }
      }
    }
    console.log(Date.now() - startTime1, " this is the timer");
    boundingTreeCount--;
    let state = 0;
    const rootsValuesArr = Object.values(rootsValues);

    addEventListener(null, "keydown", key => {
      if (key.key === "w") {
        enableLayersOf(rootsValuesArr[++state % rootsValuesArr.length]);
      }
    });
  }

  /**
   * Hides and unhide IPRs based on angle between the cam and the IPR
   */

  useEffect(() => {
    measurementTool.attach({
      scene,
      camera,
      controls: controlsRef.current,
      canvas: canvas.current,
    });
    /* measurementTool.addNewObjectsToCheck([
      groupRef?.current?.children[currentStep].children[0],
      groupRef?.current?.children[currentStep].children[1],
    ]); */
    for (let isLower = 0; isLower < 2; isLower++) {
      groupRef?.current?.children[currentStep].children[
        isLower
      ].children.forEach(tooth => {
        measurementTool.addNewObjectToCheck(tooth);
        measurementTool.addNewObjectToCheck(tooth.children[3].children[0]);

        tooth.children[0].children.forEach(att => {
          measurementTool.addNewObjectToCheck(att);
        });
      });
    }
    return () => {
      measurementTool.dispose();
    };
  }, [scene, camera, controls, groupRef, currentStep]);

  useEffect(() => {
    if (!mainScene) {
      mainScene = scene;
    } else {
      console.error("scene reloaded");
    }
  }, [scene]);
  useEffect(() => {
    if (groupRef2.current) {
      splitScene = groupRef2.current.parent;
      splitScene.add(occlusalSplitGroup);
    }
  }, [groupRef2]);

  useEffect(() => {
    if (groupRef.current) {
      scene.add(occlusalMainGroup);
    }
  }, [groupRef]);
  function prepareBoundingTrees(geometry) {
    if (!geometry.attributes.position) {
      console.warn("not valid geometry");
      return;
    }
    geometry.computeBoundsTree({ indirect: true });
  }

  function reflectIPRVision() {
    if (!globalData.isActive.ipr || !globalData.hasIPR) {
      return;
    }
    const angleAllowed = 90;
    const allowedYOffset = 100;
    let inc = 1;
    let gumCenter = new THREE.Vector3(),
      tempCasher = new THREE.Vector3();
    let state = false;
    let mainStep = currentStep;
    for (let archIndex = 0; archIndex < 2; archIndex++) {
      for (
        let toothIndex = 0;
        toothIndex <
        groupRef.current.children[mainStep].children[archIndex].children.length;
        toothIndex++
      ) {
        for (
          let iprIndex = 0;
          iprIndex <
          groupRef.current?.children[mainStep].children[archIndex]?.children[
            toothIndex
          ]?.children[2]?.children.length;
          iprIndex++
        ) {
          if (inc === 1) {
            inc = 2;
            const box3 = new THREE.Box3().setFromObject(
              groupRef.current?.children[mainStep].children[archIndex]
                .children[0],
            );
            box3.getCenter(gumCenter);
          }
          const box3 = new THREE.Box3().setFromObject(
            groupRef.current.children[mainStep].children[archIndex].children[
              toothIndex
            ].children[2],
          );
          box3.getCenter(tempCasher);

          const yResult = Math.abs(
            (Math.atan2(camera.position.x, camera.position.z) -
              Math.atan2(gumCenter.x, gumCenter.z)) *
              (180 / Math.PI) -
              (Math.atan2(tempCasher.x, tempCasher.z) -
                Math.atan2(gumCenter.x, gumCenter.z)) *
                (180 / Math.PI),
          );

          if (
            yResult > angleAllowed &&
            Math.abs(camera.position.y) < allowedYOffset
          ) {
            groupRef.current.children[mainStep].children[archIndex].children[
              toothIndex
            ].children[2].visible = false;
            state = false;
          } else {
            groupRef.current.children[mainStep].children[archIndex].children[
              toothIndex
            ].children[2].visible =
              globalData.isActive.ipr || !globalData.hasIPR;
            state = true;
          }
        }
      }
    }
  }

  function createRootAnchors(teethTransformationData) {
    const loader = new GLTFLoader();
    loader.load("RootAnchors.glb", function (rootAnchor) {
      const maxStepNumber = GLBData.length - 1;
      const parentUpper = groupRef.current.children[maxStepNumber].children[0];
      const parentLower = groupRef.current.children[maxStepNumber].children[1];
      let cloneHolder;

      parentUpper.children.forEach(item => {
        let teethNumberMinusOne = item.name.split("_")[2].substring(1) - 1;
        if (teethTransformationData[teethNumberMinusOne]) {
          cloneHolder = rootAnchor.scene.children[0].clone();
          cloneHolder.scale.set(100, 100, 100);
          cloneHolder.name = "rootAnchor";
          cloneHolder.updateMatrixWorld();
          const geometry = new THREE.BoxGeometry(1, 1, 1);
          const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
          const cube = new THREE.Mesh(geometry, material);
          const cube1 = new THREE.Mesh(geometry, material);
          cube.position.set(
            teethTransformationData[teethNumberMinusOne]
              .ToothRotationCenter[0] + parentUpper.parent.position.x,
            teethTransformationData[teethNumberMinusOne]
              .ToothRotationCenter[1] + parentUpper.parent.position.y,
            teethTransformationData[teethNumberMinusOne]
              .ToothRotationCenter[2] + parentUpper.parent.position.z,
          );
          cube1.position.set(
            cube.position.x -
              teethTransformationData[teethNumberMinusOne].Up[0] * 10,
            cube.position.y -
              teethTransformationData[teethNumberMinusOne].Up[1] * 10,
            cube.position.z -
              teethTransformationData[teethNumberMinusOne].Up[2] * 10,
          );

          cloneHolder.position.set(
            cube.position.x,
            cube.position.y,
            cube.position.z,
          );
          cloneHolder.lookAt(cube1.position);
          item.children[3].attach(cloneHolder);

          cloneHolder.updateMatrixWorld();
          cloneHolder.visible = true;
        }
      });
      parentLower.children.forEach(item => {
        let teethNumberMinusOne = item.name.split("_")[2].substring(1) - 1;
        if (teethTransformationData[teethNumberMinusOne]) {
          cloneHolder = rootAnchor.scene.children[0].clone();
          cloneHolder.scale.set(100, 100, 100);
          cloneHolder.name = "rootAnchor";
          cloneHolder.updateMatrixWorld();
          const geometry = new THREE.BoxGeometry(1, 1, 1);
          const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
          const cube = new THREE.Mesh(geometry, material);
          const cube1 = new THREE.Mesh(geometry, material);
          cube.position.set(
            teethTransformationData[teethNumberMinusOne]
              .ToothRotationCenter[0] + parentLower.parent.position.x,
            teethTransformationData[teethNumberMinusOne]
              .ToothRotationCenter[1] + parentLower.parent.position.y,
            teethTransformationData[teethNumberMinusOne]
              .ToothRotationCenter[2] + parentLower.parent.position.z,
          );
          cube1.position.set(
            cube.position.x -
              teethTransformationData[teethNumberMinusOne].Up[0] * 10,
            cube.position.y -
              teethTransformationData[teethNumberMinusOne].Up[1] * 10,
            cube.position.z -
              teethTransformationData[teethNumberMinusOne].Up[2] * 10,
          );

          cloneHolder.position.set(
            cube.position.x,
            cube.position.y,
            cube.position.z,
          );
          cloneHolder.lookAt(cube1.position);
          item.children[3].attach(cloneHolder);

          cloneHolder.rotateZ(3.14);
          cloneHolder.visible = true;
        }
      });
    });
  }
  function getRayCollisionPoint(x, y, camera, collisionList) {
    const intersection = {
      intersects: false,
      point: new THREE.Vector3(),
      normal: new THREE.Vector3(),
    };
    let mouseHelper = new THREE.Mesh(
      new THREE.BoxGeometry(1, 1, 10),
      new THREE.MeshNormalMaterial(),
    );
    const mouse = new THREE.Vector2();
    let intersects = [];
    let raycaster = new THREE.Raycaster();
    raycaster.layers.enable(1);

    mouse.x = (x / window.innerWidth) * 2 - 1;
    mouse.y = -(y / window.innerHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);

    raycaster.intersectObjects(collisionList, false, intersects);
    let teethHolder;
    if (intersects.length > 0) {
      teethHolder = intersects[0];
      if (teethHolder.object != selectedAttachment.object.parent) {
        return;
      }
      const p = teethHolder.point;
      mouseHelper.position.copy(p);
      intersection.point.copy(p);
      const n = teethHolder.face.normal.clone();
      n.transformDirection(teethHolder.object.matrixWorld);
      n.multiplyScalar(10);
      n.add(teethHolder.point);

      intersection.normal.copy(teethHolder.face.normal);
      mouseHelper.lookAt(n);
      line.visible = true;
      setPositionToWorld(
        selectedAttachment.object,
        new THREE.Vector3(p.x, p.y, p.z),
        n,
      );
      // selectedAttachment.object.position.set(p.x, p.y, p.z);
      //positions.setXYZ(1, n.x, n.y, n.z);
      //selectedAttachment.needsUpdate = true;

      intersection.intersects = true;

      intersects.length = 0;
    } else {
      intersection.intersects = false;
    }
  }

  //const normalContactThreshold = -10;
  const heavyContactThreshold = 0;
  if (!rootsAreCreated && teethTransformationData) {
    setTimeout(() => {
      createRootAnchors(teethTransformationData);
    }, 1000);
    rootsAreCreated = true;
  }
  if (turnGUIOn) {
    if (guiCounter == 0) {
      guiCounter++;
      const gui = new GUI();
      gui.addColor(conf, "color").onChange(function (values) {
        teethMaterial.color = conf;
        updateState({});

        // heavyContactThreshold = conf.number;
      });
      gui.addColor(conf1, "color").onChange(function (values) {
        attachmentMaterial.specularColor = conf1;
        updateState({});

        // heavyContactThreshold = conf.number;
      });
      gui.addColor(conf5, "color").onChange(function (values) {
        teethMaterial.emissive = conf5;
        updateState({});
        teethMaterial.needsUpdate = true;

        // heavyContactThreshold = conf.number;
      });
      gui.addColor(conf2, "color").onChange(function (values) {
        gumMaterial.color = conf2;

        updateState({});
        // heavyContactThreshold = conf.number;
      });
      gui.addColor(conf3, "color").onChange(function (values) {
        gumMaterial.emissive = conf3;
        updateState({});

        // heavyContactThreshold = conf.number;
      });

      gui.addColor(conf4, "color").onChange(function (values) {
        gumMaterial.specularColor = conf4;
        updateState({});

        // heavyContactThreshold = conf.number;
      });
    }
  }

  const bgLineHeavyContactMaterial = new THREE.LineBasicMaterial({
    color: "red",
    side: THREE.DoubleSide,
    polygonOffset: true,
    polygonOffsetFactor: 1,
    polygonOffsetUnits: 1,
    blending: THREE.CustomBlending,
  });

  const bgLineNormalContactMaterial = new THREE.LineBasicMaterial({
    color: "blue",
    side: THREE.DoubleSide,
    polygonOffset: true,
    polygonOffsetFactor: 1,
    polygonOffsetUnits: 1,
    blending: THREE.CustomBlending,
    linewidth: 1,
  });

  let center = { x: 0, y: 0, z: 0 };

  function setPositionToWorld(object, position, lookAtPosition) {
    if (true) {
      // lookAtPosition.add(selectedAttachmentOffset);
      let box3 = new THREE.Box3().setFromObject(object);
      const point = new THREE.Vector3(); // attachment center
      box3.getCenter(point);

      const movementAmount = position.sub(point); // amount needed to move to reach the target position

      let objectPos = object.position.clone(); // local attachment pos
      let objectWorldPos = new THREE.Vector3(); // world attachment pos
      object.getWorldPosition(objectWorldPos);
      point.sub(objectWorldPos);

      object.position.set(0, 0, 0);
      object.lookAt(lookAtPosition);

      object.position.set(objectPos.x, objectPos.y, objectPos.z);
      let toWorldOffset = objectPos.sub(objectWorldPos); //

      let box31 = new THREE.Box3().setFromObject(object);
      const point2 = new THREE.Vector3(); // attachment center
      box31.getCenter(point2);

      const newObjectWorldPosition = point.add(objectWorldPos); // distance btw attachment and pivot point
      newObjectWorldPosition.add(toWorldOffset);

      point2.sub(objectWorldPos);
      newObjectWorldPosition.sub(point2);
      newObjectWorldPosition.add(movementAmount);

      // objectWorldPos = point2;
      // point2.add(toWorldOffset);

      // objectWorldPos.sub(t); // move the world pos by attachment distance
      // objectWorldPos.add(toWorldOffset); // make the world position to local pos

      //objectWorldPos.add(selectedAttachmentOffset);
      //objectWorldPos.add(t.x, t.y, t.z);
      object.position.set(
        newObjectWorldPosition.x,
        newObjectWorldPosition.y,
        newObjectWorldPosition.z,
      );
      once++;
    }
  }

  function checkIntersection(x, y, camera, collisionList) {
    const intersection = {
      intersects: false,
      point: new THREE.Vector3(),
      normal: new THREE.Vector3(),
    };
    let mouseHelper = new THREE.Mesh(
      new THREE.BoxGeometry(1, 1, 10),
      new THREE.MeshNormalMaterial(),
    );
    const mouse = new THREE.Vector2();
    let intersects = [];
    let raycaster = new THREE.Raycaster();
    raycaster.layers.enable(1);

    mouse.x = (x / window.innerWidth) * 2 - 1;
    mouse.y = -(y / window.innerHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);

    raycaster.intersectObjects(collisionList, false, intersects);
    let attachmentHolder;
    if (intersects.length > 0) {
      attachmentHolder = intersects[0];
      selectedAttachment = attachmentHolder;
      const p = attachmentHolder.point;
      mouseHelper.position.copy(p);
      intersection.point.copy(p);
      const n = attachmentHolder.face.normal.clone();
      n.transformDirection(attachmentHolder.object.matrixWorld);
      n.multiplyScalar(10);
      n.add(attachmentHolder.point);

      intersection.normal.copy(attachmentHolder.face.normal);
      mouseHelper.lookAt(n);

      intersection.intersects = true;

      intersects.length = 0;
      selectedAttachmentOffset = selectedAttachment.object.position
        .clone()
        .sub(p)
        .clone();
    } else {
      intersection.intersects = false;
    }
  }

  function checkIntersection2(x, y, camera, collisionList) {
    const intersection = {
      intersects: false,
      point: new THREE.Vector3(),
      normal: new THREE.Vector3(),
    };
    let mouseHelper = new THREE.Mesh(
      new THREE.BoxGeometry(1, 1, 10),
      new THREE.MeshNormalMaterial(),
    );
    const mouse = new THREE.Vector2();
    let intersects = [];
    let raycaster = new THREE.Raycaster();
    raycaster.layers.enable(1);

    mouse.x = (x / window.innerWidth) * 2 - 1;
    mouse.y = -(y / window.innerHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);

    raycaster.intersectObjects(collisionList, false, intersects);
    let attachmentHolder;
    if (intersects.length > 0) {
      attachmentHolder = intersects[0];
      selectedAttachment = attachmentHolder;
      const p = attachmentHolder.point;
      mouseHelper.position.copy(p);
      intersection.point.copy(p);
      const n = attachmentHolder.face.normal.clone();
      var ngeometry = new THREE.SphereGeometry();

      n.transformDirection(attachmentHolder.object.matrixWorld);
      n.multiplyScalar(10);
      n.add(attachmentHolder.point);

      intersection.normal.copy(attachmentHolder.face.normal);
      mouseHelper.lookAt(n);

      intersection.intersects = true;

      intersects.length = 0;
      selectedAttachmentOffset = selectedAttachment.object.position
        .clone()
        .sub(p)
        .clone();
    } else {
      intersection.intersects = false;
    }
  }
  useEffect(() => {
    console.log("tp load call");
    if (!tploaded && meshGroup) {
      const isAppleIphoneMobileDevice = !isIpad && isAppleMobile();
      Object.values(tpLookup.gumsById).forEach(child => {
        if (child.userData["super"]) {
          return;
        }

        if (child.name) {
          if (child.name.includes("st")) {
            centering_group.add(child.clone());
          }
          if (child.children.length > 0) {
            child.children.forEach(teeth => {
              // teeth.geometry = mergeVertices(teeth.geometry);
              if (isAppleIphoneMobileDevice) {
                teeth.material.flatShading = true;
              } else {
                teeth.geometry.computeVertexNormals();
              }

              teeth?.children[0]?.children.forEach(attachment => {
                attachmentsList.push(attachment);
                if (isAppleIphoneMobileDevice) {
                  attachment.material.flatShading = true;
                } else {
                  // attachment.geometry.computeVertexNormals();
                }
                // attachment.geometry = mergeVertices(attachment.geometry);
              });
            });
          }
          if (child.geometry) {
            if (isAppleIphoneMobileDevice) {
              child.material.flatShading = true;
            } else {
              child.geometry.computeVertexNormals();
            }
            // child.geometry = mergeVertices(child.geometry);
          }
        }
      });

      // if (
      //   true &&
      //   groupRef.current
      //   // GLBData[0].lower.gum &&
      //   // GLBData[0].upper.gum
      // ) {
      //   PrepareTeethMovementPath(groupRef, GLBData);
      //   calculateTeethPositions(GLBData.length - 1, groupRef);
      // }
      addRemoveAttachment(scene, perspectiveCameraRef, groupRef.current, {
        x: center.x,
        y: center.y,
        z: center.z,
      });
    }
  }, [tploaded]);
  useEffect(() => {
    ReflectNumberingToggle();
  }, [
    currentStep,
    toggle.numbering,
    toggle.showUpper,
    toggle.showLower,
    dentalNotation,
  ]);
  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`other.${group}.${key}`);
  };
  const getContent3DControls = (group, key) => {
    return content(`controls.${group}.${key}`);
  };

  function RenderCurrentStep() {
    const startTime = Date.now();
    if (!meshGroup) {
      console.log("empty mesh group");
      return;
    }

    let isActive = false;
    const lastStepNumber = globalData.maxStepNumber;
    customTeethGizmoControls.setIsEnabled(customTeethGizmoControls.isEnabled);
    for (let index = 0; index < lastStepNumber + 1; index++) {
      isActive = index === currentStep;
      meshGroup.children[index].visible = isActive;
      meshGroup.children[index].children[0].visible = toggle.showUpper;
      meshGroup.children[index].children[1].visible = toggle.showLower;

      if (rootGroup) {
        if (rootGroup.children[0]) {
          rootGroup.children[0].visible = toggle.showUpper;
        }
        if (rootGroup.children[1]) {
          rootGroup.children[1].visible = toggle.showLower;
        }
      }
    }

    if (groupRef2.current) {
      groupRef2.current.children[lastStepNumber].children[0].visible =
        toggle.showUpper;

      groupRef2.current.children[lastStepNumber].children[1].visible =
        toggle.showLower;
    }

    if (meshGroup.children[lastStepNumber].children[1]) {
      meshGroup.children[lastStepNumber + 1].visible = toggle.superImpose;
      meshGroup.children[lastStepNumber + 1].children[0].visible =
        toggle.superImpose && toggle.showUpper;
      meshGroup.children[lastStepNumber + 1].children[1].visible =
        toggle.superImpose && toggle.showLower;
    }
  }
  function ReflectNumberingToggle() {
    if (!meshGroup) {
      console.log("mesh group is empty");
      return;
    }
    //upper
    meshGroup.children[currentStep].children[0].children.forEach(tooth => {
      tooth.children[1].visible = toggle.numbering;
    });
    //lower
    meshGroup.children[currentStep].children[1].children.forEach(tooth => {
      tooth.children[1].visible = toggle.numbering;
    });
    if (!groupRef2?.current) {
      return;
    }

    const maxStepNumber = globalData.maxStepNumber;

    groupRef2.current.children[maxStepNumber].children.forEach(jaw => {
      jaw.children.forEach(tooth => {
        if (tooth.children[1]) {
          tooth.children[1].visible = toggle.numbering;
        }
      });
    });

    /* groupRef2.current.children[maxStepNumber - 1].children.forEach(tooth => {
      if (tooth.children[1]) {
        tooth.children[1].visible = toggle.numbering;
      }
    }); */

    // groupRef2.current.children.forEach(gum => {
    //   if (gum.name.includes("gum")) {
    //     gum.children.forEach(tooth => {
    //       tooth.children[1].visible = toggle.numbering;
    //     });
    //   }
    // });
  }

  let wastedTime = 0;

  function newDrawContanct(mesh1, mesh2, isForced, isFlip = false) {
    const startTime = Date.now();

    if (isFlip) {
      [mesh1, mesh2] = [mesh2, mesh1];
    }

    if (
      !isForced &&
      heatMapManager.getHeatmapsResult()[mesh1.userData["step"]][
        mesh1.userData["number"].isCalculated
      ]
    ) {
      return;
    }
    if (
      // !areBoxCollidingWithDepth(
      //   mesh1,
      //   mesh2,
      //   0.1 /* 0.1 first coloring depth */,
      // ) &&
      !areColliding(mesh1, mesh2)
    ) {
      return;
    }

    // test(isFlip, mesh1, mesh2);

    // runGPU(mesh1, mesh2);

    heatMapManager.generateHeatmap(isFlip, mesh1, mesh2);
    // gpuCalc4(isFlip, mesh1, mesh2);

    // test(isFlip, mesh1, mesh2, scene, camera, renderer);
  }

  function areBoxCollidingWithDepth(mesh1, mesh2, depthDistance) {
    const box1 = new THREE.Box3().setFromObject(mesh1); // Get bounding box for the first object
    const box2 = new THREE.Box3().setFromObject(mesh2); // Get bounding box for the second object

    // Check if the bounding boxes intersect
    return box1.intersectsBox(box2) && box2.max.y - box1.min.y > depthDistance;
  }

  /**
   * Parses a basic Wavefront OBJ file (passed in as text)
   * and extracts position vertices (v), normals (vn),
   * and faces (f) into separate arrays.
   *
   * @param {string} objText The contents of the .obj file as a string
   * @returns {Object} An object with { positions, normals, faces }
   */
  function parseOBJ(objText) {
    // Arrays to store parsed data
    const positions = [];
    const normals = [];
    // Each face is an array of objects: { vertexIndex, normalIndex }
    const faces = [];

    const lines = objText.split("\n");
    for (let line of lines) {
      line = line.trim();
      if (!line || line.startsWith("#")) {
        // Ignore empty lines or comments
        continue;
      }

      // const parts = line.split(/\s+/);
      const parts = line.split(" ");
      const keyword = parts[0];

      switch (keyword) {
        case "v": {
          // Vertex position
          // 'v x y z'
          const x = parseFloat(parts[1]);
          const y = parseFloat(parts[2]);
          const z = parseFloat(parts[3]);
          positions.push([x, y, z]);
          break;
        }

        case "vn": {
          // Vertex normal
          // 'vn x y z'
          break;
          const nx = parseFloat(parts[1]);
          const ny = parseFloat(parts[2]);
          const nz = parseFloat(parts[3]);
          normals.push([nx, ny, nz]);
          break;
        }

        case "f": {
          // Face
          // A face line may look like: f 1/2/1 2/2/1 3/2/1
          // Each chunk can have up to three indices: vertexIndex/textureIndex/normalIndex
          const faceVertices = parts.slice(1).map(faceString => {
            const indices = faceString.split("/");
            // OBJ indices are 1-based, convert to 0-based
            return {
              vertexIndex: parseInt(indices[0], 10) - 1,
              // textureIndex: indices[1] ? parseInt(indices[1], 10) - 1 : undefined, // if needed
              normalIndex: indices[2]
                ? parseInt(indices[2], 10) - 1
                : undefined,
            };
          });

          faces.push(faceVertices);
          break;
        }

        default:
          // Ignore other keywords (vt, g, o, s, etc.) for simplicity
          break;
      }
    }

    return { positions, normals, faces };
  }
  function centerGroups(step) {
    const centering_group = new THREE.Group();
    centering_group.add(step.children[0].clone());
    centering_group.add(step.children[1].clone());

    const aabb = new THREE.Box3();
    aabb.setFromObject(centering_group);
    const center = new THREE.Vector3(0, 0, 0);
    aabb.getCenter(center);

    setCenterVec({ x: center.x, y: center.y, z: center.z });

    meshGroup.position.set(-center.x, -center.y, -center.z);
    if (rootGroup) {
      rootGroup.position.set(-center.x, -center.y, -center.z);
      rootGroup.position.add(reluAlignmentVector);
    }

    occlusalMainGroup.position.copy(meshGroup.position);

    BJGroup.position.set(-center.x, -center.y, -center.z);
    meshGroup.updateMatrixWorld();
  }
  function thisIsTheApocalypse(data) {
    const allGroups = new THREE.Group();
    /*  allGroups.position.set(
      0.6101608276367223,
      6.4028605803315894,
      13.441529502998932,
    ); */
    allGroups.name = "allGroups";

    //#region root Group
    const rootTeethGroup = new THREE.Group();

    rootTeethGroup.name = "root Teeth Group";

    RB.teeth.forEach(root => {
      if (!root) {
        return;
      }
      root.material =
        SingletonManager.materialManager.getMaterial("teethMaterial");
      const tooth = root.clone();

      rootTeethGroup.add(tooth);
    });

    if (globalData.isCBCT) {
      if (RB.skull) {
        const skull = RB.skull;
        if (!skull) {
          return;
        }
        skull.material =
          SingletonManager.materialManager.getMaterial("boneMaterial");
      }
      if (RB.mandible) {
        const mandible = RB.mandible;
        if (!mandible) {
          return;
        }
        mandible.material =
          SingletonManager.materialManager.getMaterial("boneMaterial");
      }
    }

    allGroups.add(rootTeethGroup);

    //#endregion

    //#region base Teeth Group

    const baseTeethGroup = new THREE.Group();
    baseTeethGroup.name = "base Teeth Group";

    data.baseTeethGLB.forEach(toothTemp => {
      if (!toothTemp) {
        return;
      }
      const tooth = new THREE.Mesh(
        toothTemp.bufferGeometry,
        teethMaterial,
        // SingletonManager.materialManager.getMaterial("teethMaterial"),
      );

      tooth.name = `t${toothTemp.index}`;
      tooth.userData["number"] = toothTemp.index;
      tooth.userData["jaw"] = toothTemp.index < 17 ? Jaw.Upper : Jaw.Lower;
      tooth.userData["step"] = 0;
      tooth.userData["isTooth"] = true;
      tooth.layers.set(1);
      fillWithDefaultColor(tooth);

      prepareToothChildren(tooth);
      baseTeethGroup.add(tooth);
    });

    allGroups.add(baseTeethGroup);

    //#endregion

    //#region gum Group
    if (false) {
      if (data.baseGumsDiff[0]["lower"] || data.baseGumsDiff[0]["upper"]) {
        const baseGumGroup = new THREE.Group();
        baseGumGroup.name = "base gum Group";

        data.baseGumsGLB.forEach(gum => {
          if (!gum) {
            return;
          }

          const gingivaModel = new THREE.Mesh(
            gum.bufferGeometry,
            // invisibleMat,
            SingletonManager.materialManager.getMaterial("gum material"),
          );
          gingivaModel.name = gum.isLower ? "l" : "u";
          const isLower = gum.isLower ? "lower" : "upper";
          const stepNumber = 0;

          for (
            let index = 0, posIndex = 0;
            index < data.baseGumsDiff[stepNumber][isLower].index.length;
            index++
          ) {
            posIndex = data.baseGumsDiff[stepNumber][isLower].index[index] * 3;
            gingivaModel.geometry.attributes.position.array[posIndex] =
              data.baseGumsDiff[stepNumber][isLower].positions[index * 3];
            gingivaModel.geometry.attributes.position.array[posIndex + 1] =
              data.baseGumsDiff[stepNumber][isLower].positions[index * 3 + 1];
            gingivaModel.geometry.attributes.position.array[posIndex + 2] =
              data.baseGumsDiff[stepNumber][isLower].positions[index * 3 + 2];
          }
          gingivaModel.geometry.attributes.position.needsUpdate = true;

          baseGumGroup.add(gingivaModel);
        });

        allGroups.add(baseGumGroup);
      } else {
        console.log(data.baseGumsDiff[0]);
      }
      //#endregion
    }

    //#region align teeth

    const teethIncisorName = [
      "t3",
      "t4",
      "t5",
      "t6",
      "t7",
      "t8",
      "t9",
      "t10",
      "t11",
      "t12",
      "t13",
      "t14",
      "t19",
      "t20",
      "t21",
      "t22",
      "t23",
      "t24",
      "t25",
      "t26",
      "t27",
      "t28",
      "t29",
      "t30",
    ];
    let baseIncisorIndex = 0;
    for (
      let baseIndex = 0;
      baseIndex < baseTeethGroup.children.length;
      baseIndex++
    ) {
      if (teethIncisorName.includes(baseTeethGroup.children[baseIndex].name)) {
        baseIncisorIndex = baseIndex;
        break;
      }
    }

    for (let index = 0; index < rootTeethGroup.children.length; index++) {
      if (
        rootTeethGroup.children[index].name ==
        baseTeethGroup.children[baseIncisorIndex].name
      ) {
        const alignmentFunction =
          baseTeethGroup.children[baseIncisorIndex].userData["jaw"] ===
          Jaw.Upper
            ? getLowestVertex
            : getHighestVertex;
        reluAlignmentVector = alignmentFunction(
          baseTeethGroup.children[baseIncisorIndex],
        ).sub(alignmentFunction(rootTeethGroup.children[index]));
        if (rootTeethGroup) {
          rootTeethGroup.children[0].parent.position.add(reluAlignmentVector);
        }

        // rootTeethGroup.position.add(new THREE.Vector3(0, 0, 15));
        // baseTeethGroup.position.add(new THREE.Vector3(0, 0, 15));
        break;
      }
    }
    //#endregion
    // rootTeethGroup.updateMatrix(true);
    // rootTeethGroup.updateMatrixWorld(true);
    // rootTeethGroup.updateWorldMatrix(true);

    //#region verify relu
    const rootParentPairs = {};
    if (rootTeethGroup.children.length) {
      let result;
      let falseCounter = 0;
      for (
        let toothIndex = 0;
        toothIndex < rootTeethGroup.children.length;
        toothIndex++
      ) {
        result = findRootParent(
          rootTeethGroup.children[toothIndex],
          baseTeethGroup.children,
          scene,
        );
        if (result) {
          rootParentPairs[rootTeethGroup.children[toothIndex].name] = result;
        } else {
          falseCounter++;
        }
      }

      if (falseCounter > 8) {
        // console.error(
        //   "relu's file don't match the case, root gonna be disabled in this case",
        // );
        setToggle("hasRoots", false);
      } else {
        setToggle("hasRoots", true);
      }

      //#endregion

      //#region parenting
      // parentReluToBase(rootTeethGroup, baseTeethGroup);
      parentReluToBaseV2(rootTeethGroup, rootParentPairs);

      // baseTeethGroup.position.add(new THREE.Vector3(0, 0, 15));

      //#endregion
    } else {
      setToggle("hasRoots", false);
      // console.error("relu's files not found");
    }

    FETreatmentGeneration = new TreatmentSetup(
      assignBaseTeethStep(baseTeethGroup.children),
      myOTP,
      meshGroup.children,
      "MainGroup",
    );

    heatmapsGroup = meshGroup.clone(true);
    removePonticsFromGroup(heatmapsGroup);

    FETreatmentGeneration.moveToStep(globalData.maxStepNumber);
    prepareAttachmentonLastStep(
      FETreatmentGeneration.getCurrentStep(),
      setControls3D,
    );
    FETreatmentGeneration.moveToStep(0);
  }
  function removePonticsFromGroup(group) {
    for (let stepIndex = 0; stepIndex < group.children.length; stepIndex++) {
      const step = group.children[stepIndex];
      for (let archIndex = 0; archIndex < 2; archIndex++) {
        const jaw = step.children[archIndex];
        for (
          let toothIndex = 0;
          toothIndex < jaw.children.length;
          toothIndex++
        ) {
          const tooth = jaw.children[toothIndex];
          if (tooth.userData["pontic"]) {
            toothIndex--;
            tooth.removeFromParent();
          }
        }
      }
    }
  }
  function assignBaseTeethStep(teeth) {
    for (let currentIndex = 0; currentIndex < teeth.length; currentIndex++) {
      let tooth = teeth[currentIndex];
      const toothNumber = tooth.userData["number"];
      const jawIndex = toothNumber > 16 ? 1 : 0;
      const step = meshGroup.children[0].children[jawIndex];

      for (let nextIndex = 0; nextIndex < step.children.length; nextIndex++) {
        let nextTooth = step.children[nextIndex];
        if (toothNumber === nextTooth.userData["number"]) {
          // tooth.attach(tooth.children[1]);
          swapChildrenAdd(tooth, nextTooth, currentIndex, nextIndex);
          teethMeshObject[nextTooth.name] = tooth;
          swapChildrenAttach(tooth.children[1], nextTooth.children[1], 1, 1);
          swapChildrenAttach(tooth.children[2], nextTooth.children[2], 2, 2);

          swapName(tooth, nextTooth);
        }
      }
    }
    meshGroup.updateMatrixWorld();
    return [
      ...meshGroup.children[0].children[0].children,
      ...meshGroup.children[0].children[1].children,
    ];
  }

  function swapChildrenAttach(
    firstObject,
    secondObject,
    firstIndex,
    secondIndex,
  ) {
    const firstParent = firstObject.parent;
    const secondParent = secondObject.parent;
    const firstParentChildren = [...firstParent.children];
    const secondParentChildren = [...secondParent.children];

    for (let index = 0; index < firstParentChildren.length; index++) {
      firstParent.attach(
        index === firstIndex
          ? secondParentChildren[secondIndex]
          : firstParentChildren[index],
      );
    }

    for (let index = 0; index < secondParentChildren.length; index++) {
      secondParent.attach(
        index === secondIndex
          ? firstParentChildren[firstIndex]
          : secondParentChildren[index],
      );
    }
  }
  function swapChildrenAdd(firstObject, secondObject, firstIndex, secondIndex) {
    const firstParent = firstObject.parent;
    const secondParent = secondObject.parent;

    const firstParentChildren = [...firstParent.children];
    const secondParentChildren = [...secondParent.children];

    for (let index = 0; index < firstParentChildren.length; index++) {
      firstParent.add(
        index === firstIndex
          ? secondParentChildren[secondIndex]
          : firstParentChildren[index],
      );
    }
    for (let index = 0; index < secondParentChildren.length; index++) {
      secondParent.add(
        index === secondIndex
          ? firstParentChildren[firstIndex]
          : secondParentChildren[index],
      );
    }
  }
  function swapName(currentTooth, nextTooth) {
    const currentName = currentTooth.name;
    const nextName = nextTooth.name;

    currentTooth.name = nextName;
    nextTooth.name = currentName;
  }
  function prepareToothChildren(tooth) {
    const attachmentGroup = new THREE.Group(),
      numberingGroup = new THREE.Group(),
      iprGroup = new THREE.Group(),
      rootAnchorsGroup = new THREE.Group(),
      elasticsGroup = new THREE.Group();

    attachmentGroup.name = "attachments";
    numberingGroup.name = "numbering";
    iprGroup.name = "IPRs";
    rootAnchorsGroup.name = "rootAnchorsGroup";
    elasticsGroup.name = "elasticsGroup";
    numberingGroup.visible = false;

    tooth.add(attachmentGroup);
    tooth.add(numberingGroup);
    tooth.add(iprGroup);
    tooth.add(rootAnchorsGroup);
    tooth.add(elasticsGroup);
  }
  function parentReluToBase(reluGroup, baseGroup) {
    for (
      let reluIndex = 0;
      reluIndex < reluGroup.children.length;
      reluIndex++
    ) {
      let done = false;
      // reluGroup.children[reluIndex].castShadow = false;

      for (
        let baseIndex = 0;
        baseIndex < baseGroup.children.length;
        baseIndex++
      ) {
        baseGroup.children[baseIndex].castShadow = false;
        if (
          reluGroup.children[reluIndex].name ===
          baseGroup.children[baseIndex].name
        ) {
          baseGroup.children[baseIndex].children[3].attach(
            reluGroup.children[reluIndex],
          );
          done = true;
          reluIndex--;
          break;
        }
      }
      if (!done) {
        const isLower =
          parseInt(reluGroup.children[reluIndex].name.substring(1)) > 16
            ? 1
            : 0;

        if (rootGroup) {
          rootGroup.children[isLower].add(reluGroup.children[reluIndex]);
          reluIndex--;
        }
      }
    }
  }

  function parentReluToBaseV2(reluGroup, rootParentPairs) {
    for (let reluIndex = 0; reluIndex < reluGroup.children.length; ) {
      // reluGroup.children[reluIndex].castShadow = false;
      const root = reluGroup.children[reluIndex];

      if (root && rootParentPairs[root.name]) {
        rootParentPairs[root.name].castShadow = false;

        rootParentPairs[root.name].children[3].attach(
          reluGroup.children[reluIndex],
        );
      } else {
        const isLower =
          parseInt(reluGroup.children[reluIndex].name.substring(1)) > 16
            ? 1
            : 0;

        if (rootGroup) {
          rootGroup.children[isLower].add(reluGroup.children[reluIndex]);
        }
      }
    }
  }

  function PrepareMesh(GLBData, ponticsData) {
    let toothCopyCacher;

    if (
      (GLBData[0].upper.teeth.length !== 0 &&
        GLBData[0].upper.teeth[0].children.length === 0) ||
      (GLBData[0].lower.teeth.length !== 0 &&
        GLBData[0].lower.teeth[0].children.length === 0)
    ) {
      console.log("GLB not ready");
      return;
    }
    let modelGroup = new THREE.Group();
    modelGroup.name = "ts Group";
    let stepHolder, gumHolder, toothHolder;

    GLBData.forEach((gingiva, stepNumber) => {
      stepHolder = new THREE.Group();
      stepHolder.name = "step" + stepNumber;
      stepHolder.userData["step"] = stepNumber;
      tpLookup.stepsById[stepHolder.id] = stepHolder;
      modelGroup.add(stepHolder);

      gumHolder = new THREE.Mesh();

      if (gingiva.upper.gum?.name) {
        gumHolder = gingiva.upper.gum.clone();
        gumHolder.layers.set(1);
        gumHolder.userData["jaw"] = Jaw.Upper;
        gumHolder.userData["isGum"] = true;
        gumHolder.userData["step"] = stepNumber;

        disposeObject(gingiva.upper.gum);
        gumHolder.castShadow = false;
        gumHolder.receiveShadow = false;
        gumHolder.material = gumMaterial;
        gumHolder.name = gingiva.upper.gum.name;
        gumHolder.visible = stepNumber == currentStep;
        tpLookup.gumsById[gumHolder.id] = gumHolder;
        let toothNumber;
        gingiva.upper.teeth.forEach(tooth => {
          toothHolder = tooth;
          toothHolder.castShadow = false;
          toothHolder.receiveShadow = false;
          toothHolder.name = tooth.name;

          toothNumber = parseInt(
            toothHolder.name.split("_")[2].substring(1, 4),
          );

          if (ponticsData[toothNumber]) {
            toothHolder.material = ponticsTeethMaterial;
            toothHolder.userData["isPontics"] = true;
            toothHolder.layers.set(1);
          } else {
            toothHolder.material = teethMaterial;
          }

          tooth.children[0].children.forEach(attachment => {
            attachment.castShadow = false;
            attachment.receiveShadow = false;
            attachment.name = attachment.name + "_att";
            attachment.visible = true;
            attachment.material = attachmentMaterial;
          });
          toothCopyCacher = toothHolder.clone();
          toothCopyCacher.userData["number"] = toothNumber;
          toothCopyCacher.userData["jaw"] = Jaw.Upper;
          toothCopyCacher.userData["step"] = stepNumber;
          toothCopyCacher.userData["isTooth"] = true;
          disposeObject(toothHolder);
          teethMeshObject[toothCopyCacher.name] = toothCopyCacher;
          tpLookup.teethById[toothCopyCacher.id] = toothCopyCacher;
          gumHolder.add(toothCopyCacher);
        });
      }

      stepHolder.add(gumHolder);

      gumHolder = new THREE.Mesh();

      if (gingiva.lower.gum?.name) {
        gumHolder = gingiva.lower.gum.clone();
        gumHolder.layers.set(1);
        gumHolder.userData["jaw"] = Jaw.Lower;
        gumHolder.userData["isGum"] = true;
        gumHolder.userData["step"] = stepNumber;
        disposeObject(gingiva.lower.gum);
        gumHolder.castShadow = false;
        gumHolder.receiveShadow = false;
        gumHolder.material = gumMaterial;
        gumHolder.name = gingiva.lower.gum.name;
        gumHolder.visible = stepNumber == currentStep;
        tpLookup.gumsById[gumHolder.id] = gumHolder;
        let toothNumber;

        gingiva.lower.teeth.forEach(tooth => {
          toothHolder = tooth;
          toothHolder.castShadow = false;
          toothHolder.receiveShadow = false;
          toothHolder.name = tooth.name;
          toothNumber = parseInt(
            toothHolder.name.split("_")[2].substring(1, 4),
          );

          if (ponticsData[toothNumber]) {
            toothHolder.material = ponticsTeethMaterial;
            toothHolder.userData["isPontics"] = true;

            toothHolder.layers.set(1);
          } else {
            toothHolder.material = teethMaterial;
          }
          tooth.children[0].children.forEach(attachment => {
            attachment.castShadow = false;
            attachment.receiveShadow = false;
            attachment.name = attachment.name + "_att";
            attachment.visible = true;
            attachment.material = attachmentMaterial;
          });
          toothCopyCacher = toothHolder.clone();

          toothCopyCacher.userData["number"] = toothNumber;
          toothCopyCacher.userData["jaw"] = Jaw.Lower;
          toothCopyCacher.userData["step"] = stepNumber;
          toothCopyCacher.userData["isTooth"] = true;

          disposeObject(toothHolder);
          teethMeshObject[toothCopyCacher.name] = toothCopyCacher;
          tpLookup.teethById[toothCopyCacher.id] = toothCopyCacher;

          gumHolder.add(toothCopyCacher);
        });
      }
      stepHolder.add(gumHolder);
    });
    //test
    stepHolder = new THREE.Group();
    stepHolder.name = "super";
    stepHolder.userData["step"] = 0;
    tpLookup.stepsById["super"] = stepHolder;
    modelGroup.add(stepHolder);

    const superImposeMaterial = SingletonManager.materialManager.createMaterial(
      "MeshStandardMaterial",
      {
        transparent: true,
        color: 0x0000e1,
        opacity: 0.4,
        flatShading: false,
        polygonOffset: true,
        polygonOffsetFactor: -0.025,
        depthWrite: true,
        name: "superImposeMaterial",
      },
    );

    gumHolder = new THREE.Mesh();
    gumHolder.userData["jaw"] = Jaw.Upper;
    gumHolder.userData["isGum"] = true;
    gumHolder.userData["step"] = 0;
    gumHolder.userData["super"] = true;

    gumHolder.visible = false;
    gumHolder.name = "Super_Impose_st0_upper";
    tpLookup.gumsById[gumHolder.id] = gumHolder;
    GLBData[0].upper.teeth.forEach(tooth => {
      if (tooth.userData["isPontics"]) {
        return;
      }
      toothHolder = tooth.clone();
      toothHolder.userData["super"] = true;
      toothHolder.userData["number"] = parseInt(
        toothHolder.name.split("_")[2].substring(1, 4),
      );
      toothHolder.userData["jaw"] = Jaw.Lower;
      toothHolder.userData["step"] = 0;
      toothHolder.userData["isTooth"] = true;
      tpLookup.teethById[toothCopyCacher.id] = toothCopyCacher;
      toothHolder.material = superImposeMaterial;
      toothHolder.layers.set(1);
      toothHolder.name = "super_" + tooth.name;
      gumHolder.add(toothHolder);
    });
    stepHolder.add(gumHolder);
    gumHolder = new THREE.Mesh();

    gumHolder.userData["jaw"] = Jaw.Lower;
    gumHolder.userData["isGum"] = true;
    gumHolder.userData["step"] = 0;
    gumHolder.userData["super"] = true;

    gumHolder.name = "Super_Impose_st0_lower";
    tpLookup.gumsById[gumHolder.id] = gumHolder;
    GLBData[0].lower.teeth.forEach(tooth => {
      if (tooth.userData["isPontics"]) {
        return;
      }
      toothHolder = tooth.clone();
      toothHolder.userData["super"] = true;
      toothHolder.userData["number"] = parseInt(
        toothHolder.name.split("_")[2].substring(1, 4),
      );
      toothHolder.userData["jaw"] = Jaw.Lower;
      toothHolder.userData["step"] = 0;
      toothHolder.userData["isTooth"] = true;
      tpLookup.teethById[toothCopyCacher.id] = toothCopyCacher;
      toothHolder.material = superImposeMaterial;
      toothHolder.layers.set(1);

      toothHolder.name = "super_" + tooth.name;
      gumHolder.add(toothHolder);
    });
    gumHolder.visible = false;
    // gumHolder.position.add(new THREE.Vector3(0, 0, 0.1));
    stepHolder.add(gumHolder);

    return modelGroup;
  }

  function PrepareRootGroup(RB) {
    rootGroup = new THREE.Group();
    rootGroup.name = "rootGroup";

    if (RB.skull) {
      rootGroup.add(RB.skull);
    } else {
      rootGroup.add(new THREE.Group());
    }
    if (RB.mandible) {
      rootGroup.add(RB.mandible);
    } else {
      rootGroup.add(new THREE.Group());
    }

    return rootGroup;
  }
  useEffect(() => {
    if (scene) {
      Controller.setScene(scene);
    }
    if (camera) {
      Controller.setCamera(camera);
    }
    if (setAutoSave) {
      Controller.setAutoSave = setAutoSave.setAutoSave;
    }
    // if (controlsRef) Controller.setControls(controlsRef);
  }, [scene, camera, setAutoSave]);
  const handleSelectTooth = event => {
    if (!toggle.show3DControls) return;
    selectTooth(
      event,
      perspectiveCameraRef,
      raycaster,
      pointer,
      [
        ...groupRef.current.children[globalCurrentStep].children[0].children,
        ...groupRef.current.children[globalCurrentStep].children[1].children,
      ],
      teethMaterial,
      scene,
      centerVec,
      setControls3D,
      selectedTooth,
      selectedAttachmentType,
      selectedAttachment,
      numberingOverLays,
      GLBData,
      model,
      setModel,
      groupRef,
      toggle.showUpper,
      toggle.showLower,
      logs,
      setLogs,
      setScene,
      attachmentArray,
      setAutoSave.setAutoSave,
    );
  };

  useEffect(() => {
    if (!toggle.show3DControls) return;

    canvas.current?.addEventListener("pointerdown", handleSelectTooth, false);
    return () => {
      canvas.current.removeEventListener(
        "pointerdown",
        handleSelectTooth,
        false,
      );
    };
  }, [
    selectedAttachmentType,
    centerVec,
    toggle.show3DControls,
    toggle.showUpper,
    toggle.showLower,
    logs,
  ]);
  const [tpBiteJump, setTpBiteJump] = useState([]);
  const [tpWithoutBiteJump, setTpWithoutBiteJump] = useState([]);
  const [tpWithoutBiteJumpWithMod, setTpWithoutBiteJumpWithMod] = useState([]);

  const [iprOverLaysWithBiteJump, setIprOverLaysWithBiteJump] = useState(
    JSON.parse(JSON.stringify(iprOverLays)),
  );
  const [iprOverLaysWithOutBiteJump, setIprOverLaysWithOutBiteJump] = useState(
    JSON.parse(JSON.stringify(iprOverLays)),
  );
  useLayoutEffect(() => {
    Object.values(iprOverLaysWithOutBiteJump[0] || {}).forEach(iprs => {
      iprs.pop(); // Removes the last element from each array
    });
    Object.values(iprOverLaysWithOutBiteJump[1] || {}).forEach(iprs => {
      iprs.pop(); // Removes the last element from each array
    });
    Object.values(iprOverLaysWithBiteJump[0] || {}).forEach(iprs => {
      iprs.splice(-2, 1); // Removes the last element from each array
    });
    Object.values(iprOverLaysWithBiteJump[1] || {}).forEach(iprs => {
      iprs.splice(-2, 1); // Removes the last element from each array
    });
  }, []);

  useLayoutEffect(() => {
    if (!meshGroup || !FETreatmentGeneration) {
      return;
    }

    // return;

    if (!isPathReady) {
      const isAppleIphoneMobileDevice = !isIpad && isAppleMobile();

      if (!isAppleIphoneMobileDevice) {
        const tempRef = Object.values(tpLookup.stepsById);

        FETreatmentGeneration.moveToStep(globalData.maxStepNumber);
        scene.updateMatrixWorld(true);
        PrepareTeethMovementPath(
          FETreatmentGeneration.getCurrentStep().children,
          GLBData,
        ); // no need
        calculateTeethPositions(GLBData.length - 1, tempRef); // no need
        console.log("CALC Center");

        FETreatmentGeneration.moveToStep(0);
        isPathReady = true;
      }

      scene.updateMatrixWorld(true);
    }
  }, [biteJumpsSteps, maxStepNumber, tpWithoutBiteJump]);
  useEffect(() => {
    if (toggle.startRevision) {
      setToggle("biteJump", false);
      setIsBiteJumpActive(false);
    }
  }, [toggle.startRevision]);
  useEffect(() => {
    if (!isBJ) {
      return;
    }
    let upperGum, lowerGum;
    if (toggle.split || isComparingMode) {
      (upperGum =
        splitTreatmentGeneration.steps[globalData.maxStepNumber].children[0]),
        (lowerGum =
          splitTreatmentGeneration.steps[globalData.maxStepNumber].children[1]);
    } else {
      (upperGum =
        FETreatmentGeneration.steps[globalData.maxStepNumber].children[0]),
        (lowerGum =
          FETreatmentGeneration.steps[globalData.maxStepNumber].children[1]);
    }

    const isBJApplied = Boolean(upperGum.userData["isBJApplied"]);
    handleRootGroupBiteJump(
      rootGroup,
      toggle.biteJump,
      currentStep === maxStepNumber,
    );
    handleRootGroupBiteJump(rootGroupSplit, toggle.biteJump, true);

    if (isComparingMode) {
      if (toggle.biteJump && !isBJApplied) {
        upperGum.applyMatrix4(upperMatrix);
        lowerGum.applyMatrix4(lowerMatrix);

        upperGum.userData["isBJApplied"] = true;
        lowerGum.userData["isBJApplied"] = true;
      } else if (isBJApplied) {
        upperGum.applyMatrix4(upperMatrixInversed);
        lowerGum.applyMatrix4(lowerMatrixInversed);

        upperGum.userData["isBJApplied"] = false;
        lowerGum.userData["isBJApplied"] = false;
      }
    }
    if (toggle.split) {
      if (toggle.biteJump && !isBJApplied) {
        upperGum.applyMatrix4(upperMatrix);
        lowerGum.applyMatrix4(lowerMatrix);

        upperGum.userData["isBJApplied"] = true;
        lowerGum.userData["isBJApplied"] = true;
      } else if (!toggle.biteJump && isBJApplied) {
        upperGum.applyMatrix4(upperMatrixInversed);
        lowerGum.applyMatrix4(lowerMatrixInversed);

        upperGum.userData["isBJApplied"] = false;
        lowerGum.userData["isBJApplied"] = false;
      }
    }
    if (!toggle.split && !isComparingMode) {
      if (toggle.biteJump && !isBJApplied) {
        upperGum.applyMatrix4(upperMatrix);
        lowerGum.applyMatrix4(lowerMatrix);

        upperGum.userData["isBJApplied"] = true;
        lowerGum.userData["isBJApplied"] = true;
      } else if (!toggle.biteJump && isBJApplied) {
        upperGum.applyMatrix4(upperMatrixInversed);
        lowerGum.applyMatrix4(lowerMatrixInversed);

        upperGum.userData["isBJApplied"] = false;
        lowerGum.userData["isBJApplied"] = false;
      }
    }
  }, [
    toggle.biteJump,
    toggle.hasBiteJump,
    maxStepNumber,
    tpBiteJump,
    tpWithoutBiteJump,
    toggle.split,
    currentStep,
    toggle.show3DControls,
    isComparingMode,
  ]);

  function handleRootGroupBiteJump(group, isBJEnabled, isLastStep) {
    if (!group) {
      return;
    }
    const isBJApplied = group.children[0].userData["isBJApplied"];
    if (isBJEnabled) {
      if (isBJApplied) {
        if (!isLastStep) {
          group.children[0].applyMatrix4(upperMatrixInversed);
          group.children[1].applyMatrix4(lowerMatrixInversed);
          group.children[0].userData["isBJApplied"] = false;
        }
      } else {
        if (isLastStep) {
          group.children[0].applyMatrix4(upperMatrix);
          group.children[1].applyMatrix4(lowerMatrix);
          group.children[0].userData["isBJApplied"] = true;
        }
      }
    } else {
      if (isBJApplied) {
        group.children[0].applyMatrix4(upperMatrixInversed);
        group.children[1].applyMatrix4(lowerMatrixInversed);
        group.children[0].userData["isBJApplied"] = false;
      }
    }
    group.updateMatrixWorld();
  }

  useEffect(() => {
    const startTime = Date.now();
    RenderCurrentStep();
    if (occlusalAreaManager) {
      if (!toggle.occ) {
        occlusalSceneController.turnOffOcclusal();
      }
    }
    if (toggle.occ) {
      if (occlusalAreaManager) {
        if (currentStep === globalMaxStepNumber) {
          occlusalSceneController.removeOcclusalOfStep(currentStep, 0);
        }
      }
      // if (toggle.show3DControls) {
      //   resetOcclusal3DControls();
      // }

      if (!heatMapManager) {
        for (
          let lowerTeethIndex = 0;
          lowerTeethIndex <
          groupRef.current.children[currentStep].children[1].children.length;
          lowerTeethIndex++
        ) {
          let lowerTooth =
            groupRef.current.children[currentStep].children[1].children[
              lowerTeethIndex
            ];
          if (lowerTooth.userData["isPontics"]) {
            continue;
          }
          for (
            let upperTeethIndex = 0;
            upperTeethIndex <
            groupRef.current.children[currentStep].children[0].children.length;
            upperTeethIndex++
          ) {
            let upperTooth =
              groupRef.current.children[currentStep].children[0].children[
                upperTeethIndex
              ];
            if (upperTooth.userData["isPontics"]) {
              continue;
            }
            DrawContact(lowerTooth, upperTooth, false, currentStep);
          }
        }
        occlusalSceneController.setOcclusalReadyToStep(currentStep, 0);
      }
      if (toggle.split || toggle.compareModifications) {
        for (
          let t = 0;
          t <
          groupRef2.current.children[maxStepNumber].children[1].children.length;
          t++
        ) {
          let lowerTooth =
            groupRef2.current.children[maxStepNumber].children[1].children[t];
          // let lowerToothOriginal =
          //   groupRef.current.children[maxStepNumber].children[1].children[t];

          if (!lowerTooth.geometry.boundsTree) {
            lowerTooth.geometry.computeBoundsTree();
          }

          // lowerTooth.geometry = lowerToothOriginal.geometry;

          for (
            let i = 0;
            i <
            groupRef2.current.children[maxStepNumber].children[0].children
              .length;
            i++
          ) {
            let upperTooth =
              groupRef2.current.children[maxStepNumber].children[0].children[i];

            // let upperToothOriginal =
            //   groupRef.current.children[maxStepNumber].children[0].children[i];

            if (!upperTooth.geometry.boundsTree) {
              upperTooth.geometry.computeBoundsTree();
            }

            // upperTooth.geometry = upperToothOriginal.geometry;

            if (occlusalAreaManager) {
              DrawContact(lowerTooth, upperTooth, true, currentStep);
            }
          }
        }
      }
    }

    // console.log(Date.now() - startTime);
  }, [
    currentStep,
    toggle.occ,
    toggle.split,
    toggle.compareModifications,
    toggle.showLower,
    toggle.showUpper,
    toggle.superImpose,
    toggle.biteJump,
  ]);

  function prepareAttachmentonLastStep(lastStep, setControls3D) {
    let attachmentMapper = [];
    let upperLength =
      lastStep.children[0].children.length; /* - (isBJ ? 1 : 0) */
    let lowerLength =
      lastStep.children[1].children.length; /* - (isBJ ? 1 : 0) */
    if (upperLength !== 0) {
      lastStep.children[0].children.forEach(tooth => {
        if (tooth.children.length != 0) {
          attachmentMapper[tooth.userData["number"]] = [];
          tooth.children[0].children.forEach(attachment => {
            attachmentMapper[tooth.userData["number"]].push(attachment.clone());
          });
        }
      });
    }
    if (lowerLength !== 0) {
      lastStep.children[1].children.forEach(tooth => {
        if (tooth.children.length != 0) {
          attachmentMapper[tooth.userData["number"]] = [];
          tooth.children[0].children.forEach(attachment => {
            attachmentMapper[tooth.userData["number"]].push(attachment.clone());
          });
        }
      });
    }

    setAttachmentArray(attachmentMapper);

    setControls3D("attachmentArray", attachmentMapper);
  }

  function resetOcclusal3DControls() {
    for (let jawIndex = 0; jawIndex < 2; jawIndex++) {
      const gum = groupRef.current.children[maxStepNumber].children[jawIndex];
      for (let t = 0; t < gum.children.length; t++) {
        const geometry = gum.children[t].geometry;
        geometry.attributes.color = new THREE.BufferAttribute(
          new Float32Array(geometry.attributes.position.array.length).fill(1.0),
          3,
        );
      }
    }
  }
  const names = [
    "att_hbra",
    "att_vbra",
    "att_oblique",
    "att_extrusion",
    "att_biolane",
    "att_root_control",
    "att_rotational",
  ];
  if (meshGroup) {
    return (
      <group>
        <primitive ref={groupRef} object={meshGroup} />
        {rootGroup ? <primitive object={rootGroup} /> : <></>}
      </group>
    );
  } else return <></>;
}

export default Mesh;
